import api from "@/api/viktor"
import type { Workflows } from "@/types/workflows"

export async function getWorkflows() {
  let path = "/me/workflows"

  const response = await api<Workflows>({
    method: "GET",
    url: path,
  })

  return response
}
